import { useRef, useState } from "react";
import { BellIcon } from "../../../assets/icons/Bell";
import {
  Avatar,
  BodyContent,
  Footer,
  FooterContent,
  HeaderContent,
  LabelSpan,
  LabelStatus,
  NotificationItem,
  NotificationList,
  OptionItem,
  Options,
  ScrollableContainer,
  UnreadCount,
} from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { DateTime } from "luxon";
import { useOutsideDrop } from "../../../hooks/useOutsideDrop";
import { SimpleCheck } from "../../../assets/icons/SimpleCheck";
import {
  handleMarkAllNotifications,
  handleMarkOneNotification,
} from "../../../state/notification/actions";
import { toastAlert } from "../../Toastify";
import Tooltip from "@tippyjs/react";
import { useHistory } from "react-router-dom";

function sortNotifications(notifications) {
  let sortedNotifications = [...notifications];

  return sortedNotifications.sort((a, b) => {
    return DateTime.fromISO(b.createdAt) - DateTime.fromISO(a.createdAt);
  });
}

function formatData(data) {
  let dt = DateTime.fromISO(data).setLocale("pt-BR");
  let dayTime = dt.toFormat("EEEE h:mm a");
  let calendar = dt.toFormat("MMM dd, yyyy");
  return { dayTime, calendar };
}

const reformatMentions = (str) => {
  return str
    .replace(/@\[([^\]]+)\]\([^)]+\)/g, "$1")
    .replace(/#\[([^\]]+)\]\([^)]+\)/g, "#$1");
};

function splitName(username) {
  var name = username.split(" ");
  if (name.length > 1) {
    return name[0];
  } else {
    return username;
  }
}

const TippyTaskMention = ({ data }) => {
  const { flow, task } = data;

  const status = task.moment ? task.moment.currentStatus : task.status;

  const labelStatus =
    status === "doing"
      ? "Em execução"
      : status === "pending"
      ? "Pendente"
      : status === "done"
      ? "Concluído"
      : status === "doneLate"
      ? "Concluído com atraso"
      : "Atrasado";

  return (
    <div
      style={{ fontSize: ".8rem", display: "flex", flexDirection: "column" }}
    >
      <span>Fluxo: {flow.title}</span>
      {task ? (
        <>
          <span>Tarefa: {task.label}</span>
          <span>
            Status:
            <LabelStatus status={status}>{labelStatus}</LabelStatus>
          </span>
        </>
      ) : null}
    </div>
  );
};

const notificationHeaderFormat = (notification) => {
  const type = notification.type;
  const label = notification.task.label;
  const status = notification.task.moment
    ? notification.task.moment.currentStatus
    : notification.task.status;
  const flowTitle = notification.flow.title ?? "";

  if (type === "task_mention") {
    return (
      <>
        {splitName(notification.sendBy.username) + " mencionou você em: "}

        <Tooltip content={<TippyTaskMention data={notification} />}>
          <LabelSpan status={status} className="mention">
            {label} [{flowTitle}]
          </LabelSpan>
        </Tooltip>
      </>
    );
  } else if (type === "flow_mention") {
    return (
      <>
        {splitName(notification.sendBy.username) + " mencionou você em um "}
        <Tooltip>
          <span className="mention">fluxo</span>
        </Tooltip>
      </>
    );
  } else {
    return <>Você recebeu uma notificação</>;
  }
};

export function BellComponent({ redirectionFunctions, style }) {
  const [open, setOpen] = useState(false);
  const [viewAll, setViewAll] = useState(true);
  const notifications = useSelector(
    (state) => state.notification.notifications
  );
  const { task_mention: redirectTaskMentionFunction } = redirectionFunctions;

  const orderedNotications = sortNotifications(notifications);

  const dispatch = useDispatch();
  const history = useHistory();

  const containerRef = useRef(null);
  useOutsideDrop(containerRef, () => {
    setOpen(false);
  });

  const handleClickNotification = (notification) => {
    const notificationId = notification._id;
    const type = notification.type;

    if (type === "task_mention") {
      redirectTaskMentionFunction(notification, history);
      dispatch(handleMarkOneNotification(notificationId))
        .then(() => {})
        .catch((err) => {
          console.log(err);
          toastAlert({
            msg: "Ocorreu um ERRO ao limpar a notificação",
            isError: true,
          });
        });
    }

    setOpen(false);
  };

  const handleViewAllNotifications = async () => {
    if (notifications.length > 0)
      dispatch(handleMarkAllNotifications()).catch((err) => {
        console.log(err);
        toastAlert({
          msg: "Ocorreu um ERRO ao limpar as notificações",
          isError: true,
        });
      });
  };

  const unreadCount = notifications.filter(
    (notification) => !notification.read
  ).length;

  return (
    <div
      ref={containerRef}
      style={{ ...style, zIndex: 80, position: "relative" }}
    >
      {unreadCount > 0 && <UnreadCount>{unreadCount}</UnreadCount>}
      <BellIcon
        style={{
          display: "flex",
          cursor: "pointer",
        }}
        onClick={() => setOpen(!open)}
      ></BellIcon>
      <NotificationList open={open}>
        <h3>Notificações</h3>
        <Options style={{ marginBottom: "1rem" }}>
          <OptionItem viewAll={viewAll} onClick={() => setViewAll(true)}>
            Ver tudo
          </OptionItem>
          <OptionItem viewAll={!viewAll} onClick={() => setViewAll(false)}>
            Menções
          </OptionItem>
        </Options>

        <ScrollableContainer>
          {orderedNotications.length > 0 ? (
            orderedNotications.map((notification, index) => (
              <NotificationItem
                onClick={() => handleClickNotification(notification)}
                key={index}
              >
                <Avatar src={notification.sendBy.avatarURL} />
                <BodyContent>
                  <HeaderContent>
                    <span className="header-notification">
                      {notificationHeaderFormat(notification)}
                    </span>
                    {!notification.read ? (
                      <div className="new-notification" />
                    ) : null}
                  </HeaderContent>
                  <p>{reformatMentions(notification.content)}</p>
                  <FooterContent>
                    <span>{formatData(notification.createdAt).dayTime}</span>
                    <span>{formatData(notification.createdAt).calendar}</span>
                  </FooterContent>
                </BodyContent>
              </NotificationItem>
            ))
          ) : (
            <span style={{ opacity: 0.6 }}>Sem notificações</span>
          )}
        </ScrollableContainer>
        <Footer>
          <span onClick={handleViewAllNotifications}>
            <SimpleCheck height="1rem" />
            Marcar todas como lidas
          </span>
        </Footer>
      </NotificationList>
    </div>
  );
}
